import script from "./FavouriteButton.vue?vue&type=script&setup=true&lang=js"
export * from "./FavouriteButton.vue?vue&type=script&setup=true&lang=js"

import "./FavouriteButton.vue?vue&type=style&index=0&id=0acda5b8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0acda5b8"]])

export default __exports__